@if (showTabs()) {
  <aw-rules-tabs></aw-rules-tabs>
}
@if (!showTabs()) {
  <aw-rules></aw-rules>
}